import React from 'react';
import { Switch } from 'react-router-dom';
import { PatentsEnum, ResourcesEnum } from '../../api/roles/enums';
import AuthenticatedRoute from '../../components/AuthenticatedRoute/AuthenticatedRoute';
import Dashboard from '../../components/Dashboard/Dashboard';
import { URLs } from '../../config/enums';

const DashboardPage: React.FC = () => {
  return (
    <Switch>
      <AuthenticatedRoute
        exact
        path={URLs.ROOT}
        resource={ResourcesEnum.DASHBOARD}
        patent={PatentsEnum.VIEW}
      >
        <Dashboard />
      </AuthenticatedRoute>
    </Switch>
  );
};

export default DashboardPage;
